<div class="container literal-page">
  <section class="hero-card">
    <div class="hero-copy">
      <span class="hero-overline">Contenido</span>
      <h1 class="title">Literales</h1>
      <p class="hero-description">
        Gestiona textos reutilizables, revisa idiomas disponibles y edita copys del sistema desde una sola tabla.
      </p>
    </div>

    <div class="hero-actions">
      <div class="summary-pill">
        <mat-icon>translate</mat-icon>
        <div>
          <span>Total registrados</span>
          <strong>{{ totalElements }}</strong>
        </div>
      </div>

      <button mat-flat-button color="primary" class="create-button" (click)="openDetails()">
        <mat-icon>add</mat-icon>
        Nuevo literal
      </button>
    </div>
  </section>

  <section class="results-card">
    <div class="results-header">
      <div>
        <h2>Listado</h2>
        <p>{{ visibleLiterals }} visibles de {{ totalElements }} literales</p>
      </div>

      <div class="results-metrics">
        <div class="metric-chip">
          <span class="metric-label">Pagina</span>
          <strong>{{ pageIndex + 1 }}</strong>
        </div>
        <div class="metric-chip">
          <span class="metric-label">Por pagina</span>
          <strong>{{ pageSize }}</strong>
        </div>
      </div>
    </div>

    <app-data-table
      tableClass="literals-table"
      [dataSource]="literals"
      [displayedColumns]="displayedColumns"
      [emptyMessage]="'No hay literales disponibles en esta pagina.'"
      [showPaginator]="true"
      [length]="totalElements"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      [rowClickable]="true"
      [rowClass]="'literal-row'"
      (rowClick)="openDetails($event.row)"
      (page)="onPageChange($event)">
      <ng-container matColumnDef="originText">
        <th mat-header-cell *matHeaderCellDef>Key</th>
        <td mat-cell *matCellDef="let literal">
          <div class="key-cell">
            <strong>{{ literal.originText }}</strong>
            <span>ID {{ literal.id }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="translation">
        <th mat-header-cell *matHeaderCellDef>Value</th>
        <td mat-cell *matCellDef="let literal">
          <div class="translation-cell">
            <strong>{{ getTranslationPreview(literal) }}</strong>
            <span>{{ getTranslationCount(literal) }} traducciones</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="lang">
        <th mat-header-cell *matHeaderCellDef>Lang</th>
        <td mat-cell *matCellDef="let literal">
          <div class="lang-list">
            <span class="lang-chip" *ngFor="let lang of displayLangCode(literal)">{{ lang }}</span>
          </div>
        </td>
      </ng-container>
    </app-data-table>
  </section>
</div>
